import { useCallback, useState } from 'react';

import { useParams } from 'react-router';

import { DeleteForever } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Stack } from '@mui/system';

import { GatewayDeviceInstallation } from '@swagger-http/dashboard';

import { ActionCell } from '@components/table/components/table-action-cell';
import RemoveInstallationDialog from '@containers/customer/smart-energy/remove-dialog';

import styles from '@containers/customer/smart-energy/tables/components.module.scss';

export const GatewayAction = (props: GatewayDeviceInstallation) => {
    const { id, deviceGateway } = props;
    const { customerId } = useParams() as { customerId: string };

    const [isOpenDelete, setIsOpenDelete] = useState(false);

    const handleDeleteClick = useCallback(
        async (event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            setIsOpenDelete(true);
        },
        [setIsOpenDelete],
    );

    return (
        <ActionCell>
            <Stack direction="row">
                <IconButton
                    onClick={handleDeleteClick}
                    className={styles.deleteIcon}
                >
                    <DeleteForever />
                </IconButton>
            </Stack>
            {isOpenDelete ? (
                <RemoveInstallationDialog
                    installationType="gateway"
                    customerId={customerId!}
                    installationId={id || ''}
                    vendorName={
                        (deviceGateway as { [key: string]: any }).vendorName
                    }
                    handleClose={() => setIsOpenDelete(false)}
                />
            ) : null}
        </ActionCell>
    );
};
